<form
  [formGroup]="editFlorderPlanningForm"
  class="form-container edit-planning-form"
  [ngClass]="{ readonly: !panelStatus.isEdit }"
>
  <div *ngIf="panelStatus.isEdit">
    <eps-date-input
      [labelWidth]="labelWidth"
      formControlName="flowDate"
      [validRanges]="dateRanges"
      *ngIf="showDate && frequency !== 'W'"
      [busy]="flowDateValidating"
      label="FLOWS.FILTER.LABELS.FLOW_DATE"
    ></eps-date-input>
    <eps-week-input
      [labelWidth]="labelWidth"
      formControlName="flowDate"
      [busy]="flowDateValidating"
      [validRanges]="dateRanges"
      *ngIf="showDate && frequency === 'W'"
      label="FLOWS.FILTER.LABELS.FLOW_DATE"
    ></eps-week-input>
  </div>
  <div *ngIf="!panelStatus.isEdit">
    <eps-date-input
      [labelWidth]="labelWidth"
      formControlName="flowDate"
      *ngIf="showDate && frequency !== 'W'"
      readonly
      label="FLOWS.FILTER.LABELS.FLOW_DATE"
    ></eps-date-input>
    <eps-week-input
      [labelWidth]="labelWidth"
      formControlName="flowDate"
      readonly
      *ngIf="showDate && frequency === 'W'"
      label="FLOWS.FILTER.LABELS.FLOW_DATE"
    ></eps-week-input>
  </div>
  <div>
    <eps-date-input
      [labelWidth]="labelWidth"
      formControlName="transferDate"
      [readonly]="true"
      label="FLOWS.FILTER.LABELS.TRANSFER_DATE"
      *ngIf="flowDetail.planning?.transferDate"
    ></eps-date-input>
    <eps-label-body
      [labelWidth]="labelWidth"
      label="FLOWS.FILTER.LABELS.TRANSFER_DATE"
      readonly
      *ngIf="!flowDetail.planning?.transferDate"
    >
      /
    </eps-label-body>
  </div>
  <div>
    <eps-date-input
      [labelWidth]="labelWidth"
      formControlName="definitiveDate"
      [readonly]="true"
      label="FLOWS.FILTER.LABELS.DEFINITIVE_DATE"
      *ngIf="!panelStatus.isEdit && panelStatus.isView"
    ></eps-date-input>
  </div>
  <div
    class="buttons"
    *ngIf="panelStatus.isEdit"
  >
    <div class="hr-thick"></div>
    <eps-button
      type="link"
      *ngIf="panelStatus.isNew"
      (buttonClick)="cancelClicked.emit()"
      label="SHARED.BUTTONS.CANCEL"
    ></eps-button>
    <eps-button
      [disabled]="editFlorderPlanningForm.pending || !editFlorderPlanningForm.valid || flowDateValidating"
      [busy]="editFlorderPlanningForm.pending"
      (buttonClick)="!editFlorderPlanningForm.pending && editFlorderPlanningForm.valid && nextClicked.emit(editFlorderPlanningForm.value)"
      [label]="panelStatus.isNew ? 'ORDERS.PLANNING.BUTTONS.NEXT' : 'ORDERS.DETAIL.BUTTONS.SAVE'"
      submit
    ></eps-button>
  </div>
</form>
